import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";
import {IntlContext, IntlShape} from "react-intl";

import {ESopLicenses} from "@/components/license/models";
import license from "@/services/license";
import {ILicenses} from "@/services/models";

import SopModal from "@shared/sop/sop-button/SopModal";
import {renderSopDropdownMenu} from "@shared/sop/sop-button/functions";
import DropdownButton from "@toolbox/button-like/DropdownButton";
import T, {intl2Str} from "@translate/T";

interface ICreateSopButtonProps {
    project: number;
    licenses: ILicenses;

    className?: string;
    isButtonGroup?: boolean;
}

interface ICreateSopButtonState {
    showModal: boolean;
}

class CreateSopButton extends React.PureComponent<
    ICreateSopButtonProps,
    ICreateSopButtonState
> {
    public readonly state: ICreateSopButtonState = {showModal: false};

    public render() {
        if (!license.status.sops.includes(ESopLicenses.Template))
            return (
                <IntlContext.Consumer children={this.renderDropdownButton} />
            );

        return this.renderSopModal();
    }

    @boundMethod
    public async onClick() {
        this.setState({showModal: true});
    }

    @boundMethod
    private renderModal() {
        const {project, licenses} = this.props;
        const {showModal} = this.state;

        if (!showModal) {
            return null;
        }

        return (
            <SopModal
                project={project}
                licenses={licenses}
                afterClose={this.afterClose}
                hrefTarget="_blank"
            />
        );
    }

    @boundMethod
    public afterClose() {
        this.setState({showModal: false});
    }

    @boundMethod
    private renderSopModal() {
        const {className, isButtonGroup, project} = this.props;

        const style = className + " btn btn-primary";

        return (
            <React.Fragment>
                <button
                    type="button"
                    id={"new-sop-" + project}
                    className={isButtonGroup ? style + " btn-group" : style}
                    onClick={this.onClick}
                >
                    <FontAwesomeIcon
                        icon={faPlus}
                        fixedWidth={true}
                        className="mr-1"
                    />
                    <T>SOP</T>
                </button>

                {this.renderModal()}
            </React.Fragment>
        );
    }

    @boundMethod
    private renderDropdownButton(intl: IntlShape) {
        const {className, isButtonGroup, project} = this.props;

        return (
            <DropdownButton
                type="primary"
                idSuffix={"new-sop-" + project}
                classNameButton={className}
                title={intl2Str(intl, "Create new SOP")}
                isButtonGroup={isButtonGroup}
                menu={this.renderMenu}
            >
                <FontAwesomeIcon
                    icon={faPlus}
                    fixedWidth={true}
                    className="mr-1"
                />
                <T>SOP</T>
            </DropdownButton>
        );
    }

    @boundMethod
    private renderMenu() {
        const {project, licenses} = this.props;

        return renderSopDropdownMenu(project, licenses);
    }
}

export default CreateSopButton;
